import React          from 'react';
import colors         from '../../utils/colors';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
       // position:       'absolute',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        //left:           '50%',
        transform:      'translate(0%, -10px)',
        transition:     'all 0.3s',
    },
    unit: {
        height:         70,
        width:          70,
        marginLeft:     10,
        marginRight:    10,
        fontSize:       30,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        color:          colors.blue,
        border:         `1px solid ${ colors.blue }`,
        borderRadius:   '0.5em',
        transition:     'all 0.3s',
        cursor:         'default'
    }

}))

type TextProps = {
    text:        string[];
    showAnswer:  boolean;
}

const Text: React.FC<TextProps> = ({
    text,
    showAnswer,
 }) => {

 const classes = useStyles();


  return (
        <div className = { classes.root }>
           {
             text.map((val, ind) => {
                 return(
                    <div
                       key       = { `text%%%%%%_${ ind }` }
                       className = { classes.unit }
                    >
                      { ind === 4 && !showAnswer ? '?' : val }
                    </div>
                 )
             })
           }
        </div>
  );
}



export default Text;




























/* import React          from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
       // position:       'fixed',
        height:         70,
        width:          150,
       // left:           '50%',
       // transform:      'translate(-50%, 0%)',
       marginLeft:      10,
       marginRight:      10,
        fontSize:       30,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        border:         '1px solid #DDD',
        borderRadius:   '0.5em',
        transition:     'all 0.3s',
    },
    
}))

type TextProps = {
    size:        number[];
    target_size: number;
    value:       string;
}

const Text: React.FC<TextProps> = ({ 
    size, 
    target_size, 
    value,
 }) => {

 const classes = useStyles();

  const rootStyle = React.useMemo(() => {
      return {
         top: size[1]/2 - target_size/2 - 100,
      }
  },[size, target_size])

  return (
        <div 
          className = { classes.root }
          style     = { rootStyle }
        >
           { value }
        </div>
  );
}



export default Text;








 */